import React from "react";

import Background from "../../../assets/clothes/clothes-bg.png";
import Image from "../../../assets/clothes/clothes-choice-a.png";

import GamePageLayout from "../GamePageLayout";

const ClothesPage3 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("ending")}
    >
      열심히 당근하긴 했지만...
      <br />
      다 팔리진 않네.
      <br />
      어쩔 수 없다.
      <br />
      나머진 헌 옷 수거함에 넣어야겠다.
    </GamePageLayout>
  );
};

export default ClothesPage3;
